import * as Yup from "yup";

export const archiveFormSchema = Yup.object({
  archiveReason: Yup.string()
    .trim()
    .required("Reason required for archive action"),
});

export const FILTER_FIELD_NAMES_TO_COUNT = [
  "jobNumber",
  "jobName",
  "companyId",
  "jobType",
  "equipment",
  "materialCategory",
  "materialType",
  "salesPersonId",
] as const;
